export default __webpack_public_path__ + "static/pixea-19b21d2a52061d1549e409c1a19bc349.png";